module.exports = "<multi-select-menu\n  #multiSelectMenuComponent\n  (select-menu-event)=\"onLayerSelected($event)\"\n  [appearance]=\"appearance\"\n  [defaultOption]=\"{text :  'כל השכבות',\n  key : 'select-from-list',\n  icon: 'fa fa-check',\n  customValue : 'all-layers'\n  }\"\n  [length]=\"length\"\n  [menuOptions]=\"layerOptions\"\n    [showFilterBox]=\"false\">\n</multi-select-menu>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/select-layers/select-layers.component.html
// module id = ./src/app/common/select-layers/select-layers.component.html
// module chunks = main